/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tired_Steep_Parakeet_BelongInputs */

const fr_tired_steep_parakeet_belong = /** @type {(inputs: Tired_Steep_Parakeet_BelongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes séances`)
};

/**

* @param {Tired_Steep_Parakeet_BelongInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const tired_steep_parakeet_belong = /** @type {((inputs?: Tired_Steep_Parakeet_BelongInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tired_Steep_Parakeet_BelongInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_tired_steep_parakeet_belong(inputs)
});